export default function UseCaseSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* 見出し */}
        <div className="text-center mb-20">
          <p className="text-xs tracking-[0.3em] text-[#8B6BAE] uppercase mb-3">Use Case</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-3 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            利用<span className="text-[#8B6BAE]">シーン</span>
          </h2>
          <p className="text-base text-[#9B9B9B]">あなたの創作スタイルに合わせて</p>
        </div>

        {/* カードエリア */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {/* Illustrator / Creator */}
          <div className="bg-[#FAFAFA] rounded-lg overflow-hidden border border-[#F0F0F0] hover:border-[#8B6BAE]/30 transition-all">
            <div className="relative h-72">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/dea11f61a870d06dcd8bcea12b276a8c.jpeg"
                alt="イラストレーター・クリエイター"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-5 left-5">
                <h3 className="text-xl font-semibold text-white">Illustrator / Creator</h3>
              </div>
            </div>
            <div className="p-6">
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-base text-[#8B6BAE] mt-0.5"></i>
                  <span className="text-sm text-[#4A4A4A]">カフェでのラフスケッチ</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-base text-[#8B6BAE] mt-0.5"></i>
                  <span className="text-sm text-[#4A4A4A]">自宅での清書</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-base text-[#8B6BAE] mt-0.5"></i>
                  <span className="text-sm text-[#4A4A4A]">出先でのアイデアドローイング</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Thinker / Business */}
          <div className="bg-[#FAFAFA] rounded-lg overflow-hidden border border-[#F0F0F0] hover:border-[#8B6BAE]/30 transition-all">
            <div className="relative h-72">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/3b8499610508bdd9afc205f80adbe775.jpeg"
                alt="思考者・ビジネス"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-5 left-5">
                <h3 className="text-xl font-semibold text-white">Thinker / Business</h3>
              </div>
            </div>
            <div className="p-6">
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-base text-[#8B6BAE] mt-0.5"></i>
                  <span className="text-sm text-[#4A4A4A]">PDFへの手書きコメント</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-base text-[#8B6BAE] mt-0.5"></i>
                  <span className="text-sm text-[#4A4A4A]">AIで図解・思考整理</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-base text-[#8B6BAE] mt-0.5"></i>
                  <span className="text-sm text-[#4A4A4A]">プレゼン準備</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 下部メッセージ */}
        <div className="text-center">
          <p className="text-lg text-[#9B9B9B]">
            描く人のための角度は、考える人の思考も支えます。
          </p>
        </div>
      </div>
    </section>
  );
}
